module.exports = __webpack_public_path__ + "static/media/hamburgerButton.cc4cc1b5.svg";